import { Component, Vue, Prop } from 'vue-property-decorator';

export interface IPromiseOptions {
    // How often to retry in case of failure
    retryInterval?: number;

    // How often to reload, i.e. scan for tables
    reloadDataInterval?: number;

    // If true, promises will be loaded in a sequential manner
    sequential?: boolean;
}

/*
Used for loading several dependencies
*/
@Component({ })
export default class PromiseLoaderMixin extends Vue {

    public loadingPercentage: number = 0;
    public loadingCount: number = 0;
    public loadingSuccess: number = 0;

    private isDestroyed: boolean = false;
    private loadPromisesRef: number;

    public async loadPromises(promiseBuilders: Array<{name: string, promise: () => Promise<any>}>, options?: IPromiseOptions): Promise<any> {
        if (!options) {
            options = {};
        }
        // console.log('loadpromises');
        // Fake add 1, just so loading does not never go from 0 to 100%
        this.loadingCount = promiseBuilders.length + 1;
        this.loadingSuccess = 1;
        this.loadingPercentage = this.loadingSuccess / this.loadingCount * 100;

        const promisesConverted = new Array<Promise<any>>();
        for (const builder of promiseBuilders) {
            promisesConverted.push(this.buildPromise(builder, options.retryInterval || 1000));
        }
        await Promise.all(promisesConverted);

        // reload if nessesary
        if (!this.isDestroyed && options.reloadDataInterval) {
            // console.log('Schedule reload');
            this.loadPromisesRef = setTimeout((() => {
                this.loadPromises(promiseBuilders, options);
            }).bind(this), options.reloadDataInterval);
            // this.loadPromisesRef = setTimeout(async () => await this.loadPromises(promiseBuilders, options), options.reloadDataInterval);
        }
    }
    public beforeDestroy() {
        this.isDestroyed = true;
        clearTimeout(this.loadPromisesRef);
        /* Stop calling, if we're waiting */
    }

    private async buildPromise(builder: {name: string, promise: () => Promise<any>}, retryInterval: number): Promise<any> {
        let success = false;
        while (!success && !this.isDestroyed) {
            try {
                // console && console.log('Trying to fetch: ' + builder.name);
                await builder.promise();
                success = true;
                this.loadingSuccess++;
                this.loadingPercentage = this.loadingSuccess / this.loadingCount * 100;
            } catch (e) {
                // console.log('argh', e);
                await this.timeout(retryInterval);
                /* Do nothing */
            }
        }
    }

    private async timeout(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

}
